<template>
    <div class="partywork">
        <div class="box_bg_1 flex-col">
          </div>
        <div class="block_2 flex-col">
            <div class="block_3 flex-col">
            <div class="text-wrapper_9 flex-row">
                <span class="text_22">PARTY&nbsp;BUILDING&nbsp;WORK</span>
            </div>
            <div class="group_1 flex-row">
                <img class="block_2_2 flex-col"  :src="(`${partywork_1.viewPath}`)"></img>
                <!-- <div class="group_2 flex-col"></div> -->
                <div class="group_3 flex-col">
                <div class="block_4 flex-row justify-between">
                    <div class="block_5 flex-col"></div>
                    <span class="text_23">党建工作</span>
                    <div class="block_6 flex-col"></div>
                </div>
                <div class="block_7 flex-row justify-between">
                    <span class="text_24" @click="toMore('PT01')">查看更多&nbsp;&nbsp;>></span>
                </div>
                <div class="text-wrapper_10 flex-col">

                    <span class="text_25">{{partywork_1.title}}</span>
                    <span class="paragraph_1"
                    >{{partywork_1.subtitle}}</span
                    >
                    <span class="text_26" @click="selelctNews(partywork_1)">[详情]</span>
                </div>
                </div>
                <div class="text-wrapper_6 flex-col">
                    <span class="text_19">4001-300-137</span>
                  </div>
                <div class="group_4 flex-row">
                <div class="image-text_1 flex-col justify-between" style="cursor:pointer">
                    <img
                    class="label_1"
                    referrerpolicy="no-referrer"
                    src="@/assets/client/tel.png"
                    />
                    <span class="text-group_1">业务咨询</span>
                </div>
                </div>
            </div>
            <div class="group_5 flex-row">
                <div class="list_1 flex-row">
                <template  v-for="(item, index) in loopData0">
                    <img :src="(`${item.viewPath}`)" class="list-items_1 flex-col" @click="selelctNews(item)" style="cursor:pointer;"></img>
                </template>
                </div>
            </div>
            <div class="group_6 flex-row">
                <div class="block_8 flex-row justify-between">
                <template v-for="(item, index) in loopData0">
                    <div class="text-wrapper_11 flex-col" style="cursor:pointer;" @click="selelctNews(item)">
                        <span class="text_28" >{{item.title}}</span>
                    </div>
                </template>

                </div>
            </div>
            </div>
            <div class="block_9 flex-col">
            <span class="text_31">PARTY&nbsp;BUILDING&nbsp;CULTURE</span>
            <div class="block_10 flex-row justify-between">
                <div class="box_2 flex-col"></div>
                <span class="text_32">党建文化</span>
                <div class="box_3 flex-col"></div>
            </div>
            <div class="block_7_2 flex-row justify-between">
                <span class="text_24" @click="toMore('PT02')">查看更多&nbsp;&nbsp;>></span>

            </div>
            <template  v-for="(item, index) in loopData1">
                <div class="block_11 flex-row" @click="selelctNews(item)">
                    <img
                    class="image_2"
                    referrerpolicy="no-referrer"
                   :src="(`${item.viewPath}`)"
                    />
                    <div class="text-wrapper_14 flex-col justify-between">
                    <span class="text_33">{{item.title}}</span>
                    <span class="paragraph_2"
                        >{{item.subtitle}}</span
                    >
                    </div>
                </div>
            </template>
            </div>
            <div class="block_14 flex-col">
            <span class="text_36">SOCIAL&nbsp;RESPONSIBILITY</span>
            <div class="section_1 flex-row justify-between">
                <div class="block_15 flex-col"></div>
                <span class="text_37">社会责任</span>
                <div class="block_16 flex-col"></div>
            </div>
            <div class="block_7_2 flex-row justify-between">
                <span class="text_24" @click="toMore('PT03')">查看更多&nbsp;&nbsp;>></span>
            </div>
            <div class="section_2 flex-row justify-between">
                <div class="box_5 flex-col">
                    <el-carousel  loop>
                        <el-carousel-item
                          v-for="(item, index) in loopData2"
                          :key="index"
                          class="verticalCenter"
                        >
                          <xh-image-item
                            :key="index"
                            style="width:33.86vw; height: 19.38vw;z-index:9999;cursor: pointer;"
                            :imgUrl="item.viewPath"
                            :title="item.title"
                             @click="selelctNews(item)"
                          >
                          </xh-image-item>
                        </el-carousel-item>
                      </el-carousel>
                </div>
                <div class="box_6 flex-col justify-between">
                    <template v-for="(item, index) in loopData3">
                        <div class="box_6_1"  @click="selelctNews(item)">
                            <img :src="(`${item.viewPath}`)"  class="group_7" ></img>
                            <span class="text_40">{{item.title.length>100?item.title.substring(0,100)+"...":item.title}}</span>
                        </div>
                    </template>
                </div>
            </div>
            </div>
            <div class="block_18 flex-col">
            <div class="text-wrapper_18 flex-row">
                <span class="text_41">PARTY&nbsp;BUILDING&nbsp;ACTIVITIES</span>
            </div>
            <div class="section_3 flex-row justify-between">
                <div class="block_19 flex-col"></div>
                <span class="text_42">党建活动</span>
                <div class="block_20 flex-col"></div>
            </div>
            <div class="block_7_2 flex-row justify-between">
                <span class="text_24" @click="toMore('PT04')">查看更多&nbsp;&nbsp;>></span>
            </div>
            <div class="section_4">
                <el-carousel :interval="4000" type="card" height="200px">
                    <el-carousel-item v-for="(item,index) in loopData4" :key="index">
                        <img class="section_5" :src="item.viewPath" :title="item.title" @click="selelctNews(item)" style="cursor:pointer"></img>
                    </el-carousel-item>
                  </el-carousel>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
    import XhImageItem from "../../../components/XhComponents/XhImageItem.vue";
    export default{
        components: { XhImageItem },
        data(){
            return{
                form_0:{
                    pageSize:4,
                    pageIndex:1,
                    modelitem:'PT01',
                    newsmodel:'PartyType'
                },
                form_1:{
                    pageSize:3,
                    pageIndex:1,
                    modelitem:'PT02',
                    newsmodel:'PartyType'
                },
                /**轮播**/
                form_2:{
                    pageSize:6,
                    pageIndex:1,
                    modelitem:'PT03',
                    newsmodel:'PartyType',
                    is_broadcast:"1"
                },
                form_3:{
                    pageSize:3,
                    pageIndex:1,
                    modelitem:'PT03',
                    newsmodel:'PartyType',
                    is_broadcast:"0"
                },
                form_4:{
                    pageSize:99,
                    pageIndex:1,
                    modelitem:'PT04',
                    newsmodel:'PartyType',
                    is_broadcast:"1"
                },
                partywork_1:{},
                loopData0:[],
                loopData1:[],
                loopData2:[],
                loopData3:[],
                loopData4:[],
                FileAddress:"",
            }
        },
    methods:{
        getNewsCenterlist(state)
        {
            let that = this;
            let form ={};
            if(state==0){
                form = that.form_0;
            }
            if(state==1){
                form = that.form_1;
            }
            if(state==2){
                form = that.form_2;
            }
            if(state==3){
                form = that.form_3;
            }
            if(state==4){
                form = that.form_4;
            }
            that.$api.post("/Client/getNewsCenterlist", form,
                function (res) {
                    if (res.code === "200") {
                        if(state==0){
                            that.partywork_1={};
                            that.loopData0 =[];
                            for(var i=0;i<res.data.length;i++){
                            if(i==0){
                                that.partywork_1= {
                                id:res.data[0].id,
                                modelitem:res.data[i].model_item,
                                newsmodel:res.data[i].news_model,
                                title:res.data[0].news_title,
                                subtitle:res.data[0].news_subtitle,
                                publishdate:res.data[0].publishdate,
                                is_open_attachment:res.data[0].is_open_attachment,
                                url:res.data[0].url,
                                is_open_url:res.data[0].is_open_url,
                                viewPath: (that.FileAddress + res.data[0].ViewFilePath.replace(" ", "%20").replace(/\\/g, '/')),
                                FilePath:(that.FileAddress + res.data[0].FilePath.replace(" ", "%20").replace(/\\/g, '/')),
                                };
                            }else{
                                that.loopData0.push({
                                id:res.data[i].id,
                                modelitem:res.data[i].model_item,
                                newsmodel:res.data[i].news_model,
                                title:res.data[i].news_title,
                                subtitle:res.data[i].news_subtitle,
                                publishdate:res.data[i].publishdate,
                                is_open_attachment:res.data[i].is_open_attachment,
                                url:res.data[i].url,
                                is_open_url:res.data[i].is_open_url,
                                viewPath: (that.FileAddress + res.data[i].ViewFilePath.replace(" ", "%20").replace(/\\/g, '/')),
                                FilePath:(that.FileAddress + res.data[i].FilePath.replace(" ", "%20").replace(/\\/g, '/')),
                                });
                            }
                            }
                        }
                        if(state==1){
                            that.loopData1 =[];
                            for(var i=0;i<res.data.length;i++){
                                that.loopData1.push({
                                    id:res.data[i].id,
                                    modelitem:res.data[i].model_item,
                                    newsmodel:res.data[i].news_model,
                                    title:res.data[i].news_title,
                                    subtitle:res.data[i].news_subtitle,
                                    publishdate:res.data[i].publishdate,
                                    is_open_attachment:res.data[i].is_open_attachment,
                                    url:res.data[i].url,
                                    is_open_url:res.data[i].is_open_url,
                                    viewPath: (that.FileAddress + res.data[i].ViewFilePath.replace(" ", "%20").replace(/\\/g, '/')),
                                    FilePath:(that.FileAddress + res.data[i].FilePath.replace(" ", "%20").replace(/\\/g, '/')),
                                });
                            }
                        }
                        if(state==2){

                            that.loopData2 =[];
                            for(var i=0;i<res.data.length;i++){
                                that.loopData2.push({
                                    id:res.data[i].id,
                                    modelitem:res.data[i].model_item,
                                    newsmodel:res.data[i].news_model,
                                    title:res.data[i].news_title,
                                    subtitle:res.data[i].news_subtitle,
                                    publishdate:res.data[i].publishdate,
                                    is_open_attachment:res.data[i].is_open_attachment,
                                    url:res.data[i].url,
                                    is_open_url:res.data[i].is_open_url,
                                    viewPath: (that.FileAddress + res.data[i].ViewFilePath.replace(" ", "%20").replace(/\\/g, '/')),
                                    FilePath:(that.FileAddress + res.data[i].FilePath.replace(" ", "%20").replace(/\\/g, '/')),
                                });
                            }
                        }
                        if(state==3){
                            that.loopData3 =[];
                            for(var i=0;i<res.data.length;i++){
                                that.loopData3.push({
                                    id:res.data[i].id,
                                    modelitem:res.data[i].model_item,
                                    newsmodel:res.data[i].news_model,
                                    title:res.data[i].news_title,
                                    subtitle:res.data[i].news_subtitle,
                                    publishdate:res.data[i].publishdate,
                                    is_open_attachment:res.data[i].is_open_attachment,
                                    url:res.data[i].url,
                                    is_open_url:res.data[i].is_open_url,
                                    viewPath: (that.FileAddress + res.data[i].ViewFilePath.replace(" ", "%20").replace(/\\/g, '/')),
                                    FilePath:(that.FileAddress + res.data[i].FilePath.replace(" ", "%20").replace(/\\/g, '/')),
                                });
                            }
                        }
                        if(state==4){
                            that.loopData4 =[];
                            for(var i=0;i<res.data.length;i++){
                                that.loopData4.push({
                                    id:res.data[i].id,
                                    modelitem:res.data[i].model_item,
                                    newsmodel:res.data[i].news_model,
                                    title:res.data[i].news_title,
                                    subtitle:res.data[i].news_subtitle,
                                    publishdate:res.data[i].publishdate,
                                    is_open_attachment:res.data[i].is_open_attachment,
                                    url:res.data[i].url,
                                    is_open_url:res.data[i].is_open_url,
                                    viewPath: (that.FileAddress + res.data[i].ViewFilePath.replace(" ", "%20").replace(/\\/g, '/')),
                                    FilePath:(that.FileAddress + res.data[i].FilePath.replace(" ", "%20").replace(/\\/g, '/')),
                                });
                            }
                        }
                    }
                    },
                    function (res) {
                        that.$message.error("服务异常，信息出错");
                    }
                );
          },
          toMore(item)
          {
            let that = this;
            that.$router.push({
                    path: "/Client/PartyWorkMore",
                    query: {
                        modelitem:item
                    },
                });
          },
          selelctNews(item){
            var _this = this;
              if(item.is_open_attachment=='1'){
                 window.open(item.FilePath, '_blank');
              } else if(item.is_open_url=='1')
              {
                window.open(item.url, '_blank');
              }
              else{
                _this.$router.push({
                    path: "/Client/PartyWorkDetails",
                    query: {
                    id:item.id,
                    modelitem:item.modelitem,
                    newsmodel:item.newsmodel
                },
              });
              }
          }
        },
        mounted(){
            let that = this;
            that.FileAddress = process.env.VUE_APP_FileAddress.replace('fileapi/', '');
            that.getNewsCenterlist(0);
             that.getNewsCenterlist(1);
             that.getNewsCenterlist(2);
             that.getNewsCenterlist(3);
             that.getNewsCenterlist(4);
        }
    }
</script>
<style>
@import '../../../assets/client/partywork.css';
.partywork .el-carousel__container{
    height: 19.38vw !important;
}
.partywork .el-carousel {
    .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
    }
    .el-carousel__item:nth-child(2n+1) {
        background-color: #d3dce6;
    }
     .el-carousel__indicators {
        left: unset;
        transform: unset;
        bottom: 3%;
        right: 3%;
    }
     .el-carousel__button {
        width: 15px;
        height: 15px;
        border: none;
        border-radius: 50%;
        background-color: rgb(255, 255, 255);
    }
     .is-active .el-carousel__button {
        background: #f9f9fa;
    }
     .el-carousel__container {
        height: 100%;
    }
}
</style>
